module.exports = __webpack_public_path__ + "img/prescription3.88ed5857.png";